export type ContactVisibilityTargetType = 'ORG' | 'PEOPLE';

export type ContactVisibilityRuleType = 'HIDDEN' | 'RESTRICT_SELF' | 'RESTRICT_NONE';

export function contactRuleSelectionKey(
  ruleType: ContactVisibilityRuleType,
  targetType: ContactVisibilityTargetType | string,
  targetId: string
) {
  return `${ruleType}:${targetType}:${targetId}`;
}

export const CONTACT_VISIBILITY_RULE_SECTIONS: Array<{
  ruleType: ContactVisibilityRuleType;
  title: string;
  description: string;
}> = [
  {
    ruleType: 'HIDDEN',
    title: '隐藏的部门/成员',
    description: '被隐藏的部门或成员，不会显示在公司通讯录中，也无法被搜索查看',
  },
  {
    ruleType: 'RESTRICT_SELF',
    title: '限制查看外部部门',
    description: '被限制的部门或成员，只能看到本部门的通讯录',
  },
  {
    ruleType: 'RESTRICT_NONE',
    title: '限制查看所有人',
    description: '被限制的部门或成员，不能看到企业所有通讯录',
  },
];
